<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
    .modal__close(@click='overlay()')
    .modal__overlay(@click='overlay()')
    .videoModal__wrapper
      .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.caseStudies__section
    .caseStudies__section--intro
      h1 Cinemagraphs at Work
      p Cinemagraphs help top brands and small businesses stand out, compete, and drive growth in digital marketing campaigns. We put cinemagraphs to the test in this case study series, and found that cinemagraphs outperform still images, leading to higher conversions, lower costs, and better results.

  section(v-scroll='handleScroll')
    .caseStudies__content
      aside.caseStudies__content--menu
        ul#caseStudies--menu(ref='caseStudiesMenu')
          li(@click='scrollTo("#topbrands")') Top Brands
          .companies
          li.menu--active
            a(@click='scrollTo("#pepsi")') PepsiCo
          li
            a(@click='scrollTo("#microsoft")') Microsoft
          li
            a(@click='scrollTo("#mercedes")') Mercedes-Benz
          li
            a(@click='scrollTo("#bpaa")') BPAA
          li
            a(@click='scrollTo("#alberta")') Travel Alberta
          li(@click='scrollTo("#startups")') Startups
          li
            a(@click='scrollTo("#theride")') The Ride
          li
            a(@click='scrollTo("#giftagram")') Giftagram
          li
            a(@click='scrollTo("#inkbox")') Inkbox
          li(@click='scrollTo("#smbs")') SMBs
          li
            a(@click='scrollTo("#collage")') Collage
          li
            a(@click='scrollTo("#queenlaundry")') Queen Street Laundry
          li
            a(@click='scrollTo("#plentea")') Plentea
          li
            a(@click='scrollTo("#fitfactory")') Fit Factory Fitness
          li
            a(@click='scrollTo("#blackwidow")') Black Widow Tattoo
          li
            a(@click='scrollTo("#buggigattolo")') Buggigattolo
          li
            a(@click='scrollTo("#anti")') ANTI

      .caseStudies__content--videos
        select(v-model='videoOptions' v-on:change='scrollTo(videoOptions)')
          option(value='' selected disabled) Jump to Category
          option(value="#pepsi") Pepsico
          option(value="#microsoft") Microsoft
          option(value="#mercedes") Mercedes-Benz
          option(value="#bpaa") BPAA
          option(value="#alberta") Travel Alberta
          option(value="#theride") The Ride
          option(value="#giftagram") Giftagram
          option(value="#inkbox") Inkbox
          option(value="#collage") Collage
          option(value="#queenlaundry") Queen Street Laundry
          option(value="#plentea") Plentea
          option(value="#fitfactory") Fit Factory Fitness
          option(value="#blackwidow") Black Widow Tattoo
          option(value="#buggigattolo") Buggigattolo
          option(value="#anti") ANTI

        section.noBoxShadow#topbrands(ref='topbrands')
          .caseStudies__item#pepsi
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/pepsico@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/pepsico@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p PepsiCo is no stranger to generating brand awareness through visual storytelling. To launch their new lemon-lime beverage Mist Twst, they worked with Flixel Studios to test cinemagraph ads against still image ads on Facebook. The thumb-stopping engagement proved that cinemagraphs are the best way to put a twist on your campaign, and drive results.
                a(href='http://blog.flixel.com/pepsico-tests-cinemagraphs-in-facebook-ads/') Learn more
              .caseStudies--cinemagraph
                .cinemagraph__container
                  iframe(data-src='https://media.flixel.com/cinemagraph/w7rgg2byigztup3yaer1?hd=true', frameborder='0', allow='autoplay')
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 75%
                h3 Increase in CTR
              .caseStudies__metric--item
                h2 51x
                h3 Increase in Engagement
              .caseStudies__metric--item
                h2 5.62
                h3 Million Impressions
        section.noBoxShadow
          .caseStudies__item#microsoft(ref='microsoft')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/microsoft@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/microsoft@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p In a campaign promoting their new Surface product line, Microsoft tested cinemagraphs against still image ads on Facebook, Instagram, and Twitter. As Microsoft learned, holding attention and building a relationship with their audience is much more effective when living photos comes into play.
                a(href='http://blog.flixel.com/flixel-microsoft-case-study/') Learn more
              .caseStudies--cinemagraph
                .cinemagraph__container
                  iframe(data-src='https://media.flixel.com/cinemagraph/wdpcvu6zgptc417396m9?hd=true', frameborder='0', allow='autoplay')
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 110%
                h3 Increase in Engagement on Twitter
              .caseStudies__metric--item
                h2 85%
                h3 Increase in Engagement on Facebook
              .caseStudies__metric--item
                h2 45%
                h3 Decrease in Cost Per Engagement
        section.noBoxShadow
          .caseStudies__item#mercedes(ref='mercedes')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/mercedesbenz@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/mercedesbenz@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Flixel Studios helped Mercedes-Benz enter the fast lane to growing their brand awareness with living photos. Take a look at how the cinemagraph ad shared a story that resonated, and drove results on Instagram.
                a(href='http://blog.flixel.com/facebook-and-flixel-team-with-mercedes-on-first-ever-instagram-cinemagraph-ad/') Learn more
                .caseStudies__item--metrics.metrics--desktop
                  .caseStudies__metric--item
                    h2 6pt
                    h3 Lift in Brand Favourability
                  .caseStudies__metric--item
                    h2 34%
                    h3 Lift in Ad Recall
              .caseStudies--cinemagraph.caseStudies--squareCinemagraph
                .cinemagraph__container
                  iframe(data-src='https://media.flixel.com/cinemagraph/d5h7s6yxdinj8qqyox1r?hd=true', frameborder='0', allow='autoplay')
            .caseStudies__item--metrics.metrics--mobile
              .caseStudies__metric--item
                h2 6pt
                h3 Lift in Brand Favourability
              .caseStudies__metric--item
                h2 34%
                h3 Lift in Ad Recall
        section.noBoxShadow
          .caseStudies__item#bpaa(ref='bpaa')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/gobowling@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/gobowling@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p The Bowling Proprietors’ Association of America wanted to score big with a Facebook ads campaign. With the help of Flixel Studios, they created cinemagraph ads for their property GoBowling to drive real business results during the holiday season. Learn how they rolled one strike after another in this Facebook ads case study.
                a(href='http://blog.flixel.com/case-study-gobowling-elevates-facebook-ads-cinemagraphs/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=y2U-d6k4apU' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/y2U-d6k4apU/maxresdefault.jpg')
                    .playbtn
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 2.15
                h3 Million Impressions
              .caseStudies__metric--item
                h2 6.7%
                h3 CTR
              .caseStudies__metric--item
                h2 10
                h3 Relevance Score
        section.noBoxShadow
          .caseStudies__item#alberta(ref='alberta')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/travelalberta@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/travelalberta@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Calgary-based agency Critical Mass worked with Flixel to produce an award-winning cinemagraph campaign for Travel Alberta. Take a look at how they captured the beautiful Alberta, Canada in a series of cinemagraph ads that inspired travel goals, and led to higher conversions.
                a(href='http://blog.flixel.com/travel-alberta-uses-cinemagraphs-to-stop-time-and-capture-the-adventure-of-the-rockies/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=Va1Edc5AgEk' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/Va1Edc5AgEk/maxresdefault.jpg')
                    .playbtn
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 2x
                h3 Increase in Conversion Rate
              .caseStudies__metric--item
                h2 100%
                h3 Increase in Traffic to Partner Sites
        section.noBoxShadow#startups(ref='startups')
          .caseStudies__item#theride(ref='theride')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/theride@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/theride@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Meet The Ride, Canada’s get-me-there app. Looking to scale their business while being mindful of their costs, The Ride ran a split A/B test ads campaign on Facebook comparing the effectiveness of cinemagraphs against still images, resulting in the cinemagraph ad driving increases in customer acquisition at lower costs.
                a(href='http://blog.flixel.com/facebook-ads-case-study-cinemagraphs-results-small-business/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=m3cgG6qhcnI' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/m3cgG6qhcnI/maxresdefault.jpg')
                    .playbtn
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 3.9x
                h3 Increase in Conversion Rate
              .caseStudies__metric--item
                h2 65%
                h3 Decrease in Cost Per Install
        section.noBoxShadow
          .caseStudies__item#giftagram(ref='giftagram')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/giftagram@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/giftagram@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Toronto startup Giftagram offers users a simple way to purchase unique gifts through their mobile app. They used cinemagraph ads on Facebook to develop their relationship with potential customers, accentuate their products and brand story, and lower costs.
                a(href='http://blog.flixel.com/facebook-ads-case-study-cinemagraphs-giftagram/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=Zo5kYXU9DxM' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/Zo5kYXU9DxM/maxresdefault.jpg')
                    .playbtn
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 16x
                h3 Increase in Engagement
              .caseStudies__metric--item
                h2 61%
                h3 Decrease in Cost Per Install
        section.noBoxShadow
          .caseStudies__item#inkbox(ref='inkbox')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/inkbox@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/inkbox@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Inkbox, the pioneer of the two week tattoo, used cinemagraphs created with Cinemagraph Pro to scale their reach on Facebook. In an A/B test comparing cinemagraph ads against still image ads, the cinemagraph ad increased engagement and brand awareness while lowering costs better than the still image ad.
                a(href='http://blog.flixel.com/case-study-smb-inkbox-tests-cinemagraphs-vs-still-photo-ads-on-facebook/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=AdMQFqmJp98' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/AdMQFqmJp98/maxresdefault.jpg')
                    .playbtn
            .caseStudies__item--metrics
              .caseStudies__metric--item
                h2 117%
                h3 Increase in CTR
              .caseStudies__metric--item
                h2 41%
                h3 Decrease in CPC
              .caseStudies__metric--item
                h2 4pt
                h3 Increase in Relevance Score
        section.noBoxShadow#smbs(ref='smbs')
          .caseStudies__item#collage(ref='collage')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/collage@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/collage@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Collage is a free HR and benefits platform built for businesses in Canada. They use cinemagraphs to share their office hero stories on Facebook.
                a(href='http://blog.flixel.com/hr-software-small-business-shared-their-office-hero-stories-with-cinemagraphs/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=aqyQRvno1jA' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/aqyQRvno1jA/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow
          .caseStudies__item#queenlaundry(ref='queenlaundry')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/queenstreetlaundry@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/queenstreetlaundry@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Take a look at how local Toronto laundromat Queen Street Laundry uses cinemagraphs to put a spin on their storytelling.
                a(href='https://blog.flixel.com/small-business-facebook-marketing-with-cinemagraphs/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=ADIncQzGCSo' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/ADIncQzGCSo/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow
          .caseStudies__item#plentea(ref='plentea')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/plentea@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/plentea@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Driven by a passion for their product and community, Toronto tea bar Plentea explored cinemagraphs as a part of their Facebook and Instagram marketing.
                a(href='http://blog.flixel.com/plentea-small-business-effective-facebook-video-ad/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=m-N7O8Xe_As' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/m-N7O8Xe_As/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow
          .caseStudies__item#fitfactory(ref='fitfactory')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/fitfactory@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/fitfactory@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Watch how military-style Fit Factory Fitness gets their social media into shape by creating living photos with Cinemagraph Pro for iOS.
                a(href='http://blog.flixel.com/fit-factory-fitness-create-video-facebook-ads-cinemagraphs/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=9Kt4z9bqzB8' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/9Kt4z9bqzB8/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow
          .caseStudies__item#blackwidow(ref='blackwidow')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/blackwidow@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/blackwidow@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Check out how local tattoo parlour Black Widow takes their storytelling beyond the ink with cinemagraphs.
                a(href='http://blog.flixel.com/black-widow-tattoo-small-businesses-create-better-facebook-ads/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=XAR2HSxL1tw' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/XAR2HSxL1tw/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow
          .caseStudies__item#buggigattolo(ref='buggigattolo')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/buggigattolo@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/buggigattolo@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Explore how Italian restaurant Buggigatolo celebrates authentic food and community using cinemagraphs in Facebook ads.
                a(href='http://blog.flixel.com/bugigattolo-restaurant-cinemagraphs-on-facebook-ads/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=6uDXHcWIyw4' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/6uDXHcWIyw4/maxresdefault.jpg')
                    .playbtn
        section.noBoxShadow.no-divider
          .caseStudies__item#anti(ref='anti')
            .caseStudies__item--logo
              img.lazy(srcset='https://cdn.flixel.com/static/static-web/casestudies/anti@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/anti@1x.png 1x')
            .caseStudies__item--content
              .caseStudies--desc
                p Take a look at how streetwear line ANTI makes a statement by using cinemagraphs. 
                a(href='http://blog.flixel.com/small-business-facebook-ads-anti/') Learn more
              .caseStudies--cinemagraph
                .video__container
                  a(href='https://www.youtube.com/watch?v=cq255ePhDec' @click='ytModal($event)')
                    img.lazy(data-src='https://i1.ytimg.com/vi/cq255ePhDec/maxresdefault.jpg')
                    .playbtn
</template>

<script>
import Scroll from 'directives/Scroll.js';

export default {
  name: 'Case-Studies',
  metaInfo: {
    title: 'Cinemagraphs Outperform Photos in Facebook Ads | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/CaseStudies.png',
      },
      {
        'property': 'description',
        'content': 'Cinemagraphs drive higher conversions and lower costs in Facebook ads, social media, and digital marketing. Learn more from this Flixel Case Study Series.',
      },
    ],
  },
  data() {
    return {
      modalShow: false,
      videoOptions: '',
      ytVideo: '',
    };
  },
  directives: {
    scroll: Scroll,
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  methods: {
    handleScroll() {
      const caseStudiesPos = this.$refs.topbrands.offsetTop;
      const currentPos = window.pageYOffset;
      if (currentPos >= caseStudiesPos) {
        this.$refs.caseStudiesMenu.classList.add('fixed');
        $('.caseStudies__content--videos section').each(function (i) {
          if ($(this).position().top <= currentPos + 500) {
            $('aside a.menu--active').removeClass('menu--active');
            $('aside a').eq(i).addClass('menu--active');
          }
        });
      } else {
        this.$refs.caseStudiesMenu.classList.remove('fixed');
      }
    },
    scrollTo(id) {
      $('html, body').animate({ scrollTop: $(id).offset().top - 100 }, 800);
    },
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      this.modalShow = true;
      this.ytVideo = '<iframe src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      this.modalShow = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/CaseStudies.vue